type ToastKind = 'erro' | 'sucesso';

function showToast(kind: ToastKind, header: string, messages: string[]): void {
    if (typeof document === 'undefined' || messages.length === 0) {
        return;
    }

    const toast = document.createElement('div');
    toast.className = `app-notification-toast app-notification-toast--${kind === 'erro' ? 'erro' : 'sucesso'}`;

    const content = document.createElement('div');
    content.className = 'app-notification-toast__conteudo';

    const title = document.createElement('div');
    title.className = 'app-notification-toast__titulo';
    title.textContent = header;

    const list = document.createElement('ul');
    list.className = 'app-notification-toast__lista';
    messages.forEach((message) => {
        const item = document.createElement('li');
        item.textContent = message;
        list.appendChild(item);
    });

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'app-notification-toast__fechar';
    closeBtn.setAttribute('aria-label', 'Fechar');
    closeBtn.textContent = '×';
    closeBtn.onclick = () => toast.remove();

    content.appendChild(title);
    content.appendChild(list);
    toast.appendChild(content);
    toast.appendChild(closeBtn);
    document.body.appendChild(toast);

    window.setTimeout(() => {
        toast.remove();
    }, kind === 'erro' ? 5000 : 3000);
}

export function notificarErro(errors: string[]): void {
    showToast('erro', 'Atenção', errors);
}

export function notificarSucesso(messages: string[]): void {
    showToast('sucesso', 'Sucesso', messages);
}
